<template>
  <div
    class="c-dropdown"
    :class="isOpen ? 'is-open' : ''"
    v-click-outside="close"
  >
    <div class="c-dropdown__toggle" @click="toggle">
      <span class="c-dropdown__toggle_text">
        {{ toggleText }}
      </span>

      <img
        class="c-dropdown__toggle_icon"
        src="@/assets/img/triangle--light--down.svg"
      />
    </div>

    <div class="c-dropdown__body">
      <slot></slot>
    </div>
  </div>
</template>


<script>
import clickOutside from "@/directives/click-outside";

export default {
  props: {
    toggleText: {
      type: String,
      default: "Click to open/close",
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  directives: {
    "click-outside": clickOutside,
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },

    close() {
      this.isOpen = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.c-dropdown {
  display: inline-block;
  position: relative;
}

.c-dropdown__toggle {
  background-color: $brand-d2;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  border-radius: 3px;
  padding: 13px 16px;
  cursor: pointer;
}

.c-dropdown__toggle_text,
.c-dropdown__toggle_icon {
  vertical-align: middle;
}

.c-dropdown__toggle_text {
  margin-right: 2em;
}

.c-dropdown__toggle_icon {
  margin-top: 2px;
  transition: 0.2s;
}

.is-open .c-dropdown__toggle_icon {
  transform: rotateZ(180deg);
}

.c-dropdown__body {
  $bg: $black-2;
  $arrow-height: 13.5px;

  position: absolute;
  z-index: 1;
  top: 100%;
  right: 0;
  background: $bg;
  color: #fff;
  box-shadow: -1px 4px 4px rgba(0, 0, 0, 0.25);
  margin-top: $arrow-height + 5px;
  padding: 32px 8px;

  transition: 0.2s;

  //closed
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);

  &:after {
    content: "";
    position: absolute;
    bottom: 100%;
    right: 8.5px;
    border: $arrow-height solid transparent;
    border-top: 0;
    border-bottom-color: $bg;
  }
}

.is-open .c-dropdown__body {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}
</style>